import React from 'react';
import './StatusPill.css';

const StatusPill = ({
  children,
  tone = 'neutral',
  className = '',
}) => (
  <span className={`ui-status-pill ui-status-pill-${tone} ${className}`.trim()}>
    <span className="ui-status-pill-dot" aria-hidden="true" />
    <span>{children}</span>
  </span>
);

export default StatusPill;
